import React from "react";
import { createPortal } from "react-dom";
import { cn } from "@/lib/utils";

// Dialog components
function Dialog({ open, onOpenChange, children }) {
  if (!open) return null;
  
  return createPortal(
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      role="dialog"
      aria-modal="true"
      onClick={() => onOpenChange(false)}
    >
      <div onClick={(e) => e.stopPropagation()} className="w-full max-w-lg">
        {children}
      </div>
    </div>,
    document.body
  );
}

function DialogContent({ className, children }) {
  return <div className={cn("rounded-soft border bg-white p-5", className)}>{children}</div>;
}

function DialogHeader({ children }) {
  return <div className="mb-3 space-y-1">{children}</div>;
}

function DialogTitle({ children }) {
  return <h4 className="text-lg font-semibold">{children}</h4>;
}

function DialogDescription({ children }) {
  return <p className="text-sm text-neutral-600">{children}</p>;
}

function DialogFooter({ children, className }) {
  return <div className={cn("mt-4 flex items-center justify-end gap-2", className)}>{children}</div>;
}

export { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter };
